'use es6';

export const TX111_TREATMENT_KEY = 'tx-111';
export const TX111_GROUP_PARAMETER_KEY = 'group';
export const TX111_GROUP_PARAMETER_OPTIONS = {
  control: 'control',
  variant_B: 'extend',
  variant_C: '30days'
};